<template>
  <!-- 链接 Item 容器 -->
  <div class="link-item-container">
    <div class="link-item">
      <div class="url" @click="clickUrl(url)">{{ url.substring(8) }}</div>

      <div class="button-copy" @click="clickCopyUrl(url)">
        {{ copyUrlBtnText }}
      </div>

      <div class="button-qrcode" @click="clickDownloadQRCode(name, url)">
        二维码
      </div>
    </div>

    <!-- 链接名称 -->
    <div class="link-name">{{ name }}</div>
  </div>
</template>

<script setup>
import Tracking from "@/model/tracking.js";
import { useUploadDialog } from "@/composables";

defineProps({
  url: String,
  name: String,
});

const {
  // 状态
  state: { copyUrlBtnText, DialogSceneEnum, uploadDialogSceneType },

  // 方法
  action: { copyUrl, downloadQRCode },
} = useUploadDialog();

// 点击事件：点击 URL
const clickUrl = (url) => {
  Tracking.send({
    trigger: "button-click",
    page: "main-page",
    dialog: "upload-successful-dialog",
    object: "click-link-btn",
    scene:
      uploadDialogSceneType.value === DialogSceneEnum.PERMANENT_FILE
        ? "permanent"
        : "temporary",
  });
  window.open(url);
};

// 点击事件：点击复制 url
const clickCopyUrl = (url) => {
  Tracking.send({
    trigger: "button-click",
    page: "main-page",
    dialog: "upload-successful-dialog",
    object: "copy-link-btn",
    scene:
      uploadDialogSceneType.value === DialogSceneEnum.PERMANENT_FILE
        ? "permanent"
        : "temporary",
  });
  copyUrl(url);
};

// 点击事件：点击下载二维码
const clickDownloadQRCode = async (name, url) => {
  Tracking.send({
    trigger: "button-click",
    page: "main-page",
    dialog: "upload-successful-dialog",
    object: "download-qrcode-btn",
    scene:
      uploadDialogSceneType.value === DialogSceneEnum.PERMANENT_FILE
        ? "permanent"
        : "temporary",
  });
  downloadQRCode(name, url);
};
</script>

<style lang="scss" scoped>
.link-item-container {
  width: px2rem(304);
  margin-bottom: px2rem(15);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .link-item {
    width: px2rem(304);
    height: px2rem(47);
    background: #ffffff;
    border-radius: px2rem(3);
    display: flex;
    align-items: center;
    position: relative;

    .url {
      color: #2564dd;
      font-size: px2rem(13);
      font-family: "思源黑体 Regular";
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-left: px2rem(15);
      min-width: px2rem(120);
    }

    .button-copy {
      position: absolute;
      right: px2rem(66);
      top: 0;
      bottom: 0;
      margin-top: auto;
      margin-bottom: auto;
      background: #19725e;
      width: px2rem(55);
      height: px2rem(35);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: px2rem(3);
      box-shadow: 0 px2rem(3) px2rem(6) rgba(0, 0, 0, 0.16);
      font-family: "思源黑体 Medium";
      font-size: px2rem(13);
      color: #ffffff;
      cursor: pointer;
    }

    .button-qrcode {
      width: px2rem(55);
      height: px2rem(35);
      position: absolute;
      margin-top: auto;
      margin-bottom: auto;
      border: px2rem(1) solid #19725e;
      border-radius: px2rem(3);
      font-size: px2rem(13);
      font-family: "思源黑体 Medium";
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #19725e;
      box-shadow: 0 px2rem(3) px2rem(6) rgba(0, 0, 0, 0.16);
      cursor: pointer;
      right: px2rem(6);
      top: 0;
      bottom: 0;
    }
  }

  .link-name {
    margin-top: px2rem(4);
    margin-left: px2rem(5);
    font-family: "思源黑体 Medium";
    font-size: px2rem(13);
    color: #ffffff;
    word-wrap: break-word;
    word-break: break-all;
    width: 100%;
  }
}

// @media only screen and (orientation: landscape) {
//   .link-item-container {
//     width: 23.7vw;
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     margin-bottom: 3.52vh;

//     .link-item {
//       width: 23.7vw;
//       height: 6.57vh;
//       background: #ffffff;
//       border-radius: 0.46vh;
//       display: flex;
//       align-items: center;
//       position: relative;

//       .icon-link {
//         width: 1.75vh;
//         height: 1.75vh;
//         margin-left: 1.04vw;
//         margin-right: 0.57vw;
//       }

//       .url {
//         width: 13.33vw;
//         color: #2564dd;
//         font-size: 1.85vh;
//         font-family: "思源黑体 Regular";
//         cursor: pointer;
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         overflow: hidden;
//         margin-left: 1.15vw;
//       }

//       .button-qrcode {
//         width: 4.27vw;
//         height: 4.91vh;
//         position: absolute;
//         margin-top: auto;
//         margin-bottom: auto;
//         border: 0.19vh solid #19725e;
//         border-radius: 0.46vh;
//         font-size: 1.76vh;
//         font-family: "思源黑体 Medium";
//         box-sizing: border-box;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         color: #19725e;
//         box-shadow: 0 0.28vh 0.56vh rgba(0, 0, 0, 0.16);
//         cursor: pointer;
//         right: 0.52vw;
//         top: 0;
//         bottom: 0;
//       }

//       .button-copy {
//         position: absolute;
//         right: 5.26vw;
//         top: 0;
//         bottom: 0;
//         margin-top: auto;
//         margin-bottom: auto;
//         background: #19725e;
//         width: 4.27vw;
//         height: 4.91vh;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         border-radius: 0.46vh;
//         box-shadow: 0 0.28vh 0.56vh rgba(0, 0, 0, 0.16);
//         font-family: "思源黑体 Medium";
//         font-size: 1.76vh;
//         color: #ffffff;
//         cursor: pointer;
//       }
//     }

//     .link-name {
//       margin-top: 0.28vh;
//       margin-left: 0.36vw;
//       font-family: "思源黑体 Medium";
//       font-size: 1.85vh;
//       color: #ffffff;
//     }
//   }
// }

// @media only screen and (orientation: portrait) {
//   .link-item-container {
//     width: 77.6vw;
//     display: flex;
//     flex-direction: column;
//     align-items: flex-start;
//     margin-bottom: 2.96vh;

//     .link-item {
//       width: 77.6vw;
//       height: 5.56vh;
//       background: #ffffff;
//       border-radius: 0.46vh;
//       display: flex;
//       align-items: center;
//       position: relative;

//       .icon-link {
//         width: 1.75vh;
//         height: 1.75vh;
//         margin-left: 1.04vw;
//         margin-right: 0.57vw;
//       }

//       .url {
//         width: 43.4vw;
//         color: #2564dd;
//         font-size: 1.57vh;
//         font-family: "思源黑体 Regular";
//         cursor: pointer;
//         white-space: nowrap;
//         text-overflow: ellipsis;
//         margin-left: 3.5vw;
//         overflow: hidden;
//       }
//       .button-qrcode {
//         width: 14vw;
//         height: 4.17vh;
//         position: absolute;
//         right: 1.8vw;
//         top: 0;
//         bottom: 0;
//         margin-top: auto;
//         margin-bottom: auto;
//         border: 0.19vh solid #19725e;
//         border-radius: 0.28vh;
//         font-size: 1.39vh;
//         font-family: "思源黑体 Medium";
//         box-sizing: border-box;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         color: #19725e;
//         cursor: pointer;
//         box-shadow: 0 0.28vh 0.56vh rgba(0, 0, 0, 0.16);
//       }

//       .button-copy {
//         position: absolute;
//         right: 17vw;
//         top: 0;
//         bottom: 0;
//         margin-top: auto;
//         margin-bottom: auto;
//         background: #19725e;
//         width: 14vw;
//         height: 4.17vh;
//         display: flex;
//         align-items: center;
//         justify-content: center;
//         border-radius: 0.28vh;
//         box-shadow: 0 0.28vh 0.56vh rgba(0, 0, 0, 0.16);
//         font-family: "思源黑体 Medium";
//         font-size: 1.39vh;
//         color: #ffffff;
//         cursor: pointer;
//       }
//     }

//     .link-name {
//       margin-top: 0.28vh;
//       margin-left: 1.2vw;
//       font-family: "思源黑体 Medium";
//       font-size: 1.57vh;
//       color: #ffffff;
//     }
//   }
// }
</style>
